<template>
  <div class="login_forget_register_box pull-right">
    <section class="login_box switchover login_box_1">
      <div class="box_info">
        <div class="switchover_btn text-center h4" id="cloudLogin">
          登录
        </div>
        <div class="login_box_info">
          <h5 class="h4 login_title">账户密码登录</h5>
          <div class="login_form_box">
            <form action="#" method="">
              <div class="user login_mbtm6">
                <label class="label_focus" for="login_user_name">手机号码</label>
                <input type="text" @keyup.enter="login" class="form-control input_focus login_form" id="login_user_name"
                       v-model="username"/>
              </div>
              <div class="password login_mbtm6">
                <label class="label_focus" for="login_psw">密码</label>
                <input type="password" @keyup.enter="login" class="form-control input_focus login_form" id="login_psw"
                       v-model="password"/>
              </div>
              <div class="forget_yzm login_mbtm6">
                <label class="label_focus" for="forget_yzm">验证码</label>
                <input type="text" class="form-control inline-block input_focus login_form" @keyup.enter="login"
                       id="forget_yzm" v-model="yanzm"/>
                <div class="yzm_box inline-block">
                  <img id="verifyImg" @click="fleshVerify('verifyImg')"></img>
                </div>
                <i class="glyphicon icon_reload" @click="fleshVerify('verifyImg')" id="cloudFreshenOne"></i>
              </div>
              <p class="tip_box vis-hide denglu">
                <small class="tip_yz">密码错误！</small>
              </p>
              <p class="login_btn_box text-center">
                <a href="javascript:void(0);" class="btn btn_h btn_issue" @click="login()" id="ypt_login">登录</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
    <section class="forget_box switchover login_box_2">
      <div class="box_info">
        <div class="switchover_btn text-center h4 switchover_btn1" @click="fleshVerify('verifyImg2')"
             id="cloudForgetOne">
          忘记密码
        </div>
        <div class="forget_box_info">
          <h5 class="h4 login_title">找回密码</h5>
          <div class="forget_form_box">
            <form action="#" method="">
              <div class="forget_user login_mbtm6">
                <label class="label_focus" for="forget_user_name">手机号码</label>
                <input type="text" @keyup.enter="updatePassword" class="form-control input_focus login_form"
                       id="forget_user_name" v-model.trim="user.mobile"/>
              </div>
              <div class="forget_yzm login_mbtm6">
                <label class="label_focus" for="forget_yzm1">验证码</label>
                <input type="text" @keyup.enter="updatePassword"
                       class="form-control inline-block input_focus login_form" id="forget_yzm1"
                       v-model.trim="user.yzm"/>
                <div class="yzm_box inline-block">
                  <img id="verifyImg2" @click="fleshVerify('verifyImg2')"></img>
                </div>
                <i class="glyphicon icon_reload" @click="fleshVerify('verifyImg2')" id="cloudFreshenTwo"></i>
              </div>
              <p class="tip_box ">
                <small class="tip_yz"></small>
              </p>
              <p class="login_btn_box text-center">
                <a href="javascript:void(0);" class="btn btn_h btn_issue" @click="updatePassword()" id="cloudForgetPwd">确定</a>
              </p>
            </form>
          </div>
        </div>
        <div class="switchover_btn text-center h4 switchover_btn2" @click="fleshVerify('verifyImg2')"
             id="cloudForgetTwo">
          忘记密码
        </div>
      </div>
    </section>
    <section class="register_box switchover login_box_3">
      <div class="box_info">
        <div class="register_box_info">
          <h5 class="h4 login_title">注册新账号</h5>
          <!--注册账号入口-->
          <router-view></router-view>
        </div>
        <div class="switchover_btn text-center h4" @click="fleshVerify('verifyImg1')" id="cloudRegister">
          注册
        </div>
      </div>
    </section>

  </div>
</template>

<script>

  export default {
    name: 'login_index',
    data() {
      return {
        trueFlag: false,
        falseFlag: false,
        tipText: '',
        username: '',
        password: '',
        islogin: 1,
        yanzm: '',
        istrue: 0,
        user: {
          mobile: "",
          yzm: ""
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.inputFocus();
        this.switchover();
        this.fleshVerify('verifyImg2');
        //remove token
        localStorage.removeItem("token");
        localStorage.removeItem('loginUserType');
      })
    },
    methods: {
      login() {
        var temp = this;
        var username = this.username;
        var password = this.password;
        var checkCode=this.yanzm;
        if (username.trim() == '') {
          $(".denglu").removeClass("vis-hide");
          $(".tip_yz").text('手机号不能为空');
          return;
        } else if (password.trim() == '') {
          $(".denglu").removeClass("vis-hide");
          $(".tip_yz").text('密码不能为空');
          return;
        }

        if (temp.istrue == 0) {
          $(".denglu").addClass("vis-hide");
          this.$http.post('/zklccloud/weblogin', {
            "username": aesMinEncrypt(username),
            "password": aesMinEncrypt(password),
            "checkCode":checkCode
          }, {emulateJSON: true}).then(function (m) {
            //如果登录成功
            if(m.body.access_token){
              localStorage.setItem("token", m.body.access_token);
              this.$http.post('/zklccloud/findTCloudUser', {"access_token": m.body.access_token}, {emulateJSON: true}).then(function (m) {
                if (m.body.content.userInfo == null) {//说明无角色
                  localStorage.setItem('loginUserType', "unrole");
                  //切换至角色选择
                  var switchover = $(".switchover");

                  $(switchover[0]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_3")
                  $(switchover[1]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_2")
                  $(switchover[2]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_1")
                  $(switchover[2]).css('height', 'auto')
                  this.$router.replace('/register_success');
                } else {
                  var userType = new String(m.body.content.userInfo.userType);
                  localStorage.setItem('loginUserType', userType);
                  this.$router.push("/developer_index");
                }
              });
            }
          }, function (err) {
            if(err.body.errorMsg=='userError'){
              this.fleshVerify('verifyImg');
              temp.islogin++;
              $(".denglu").removeClass("vis-hide");
              $(".tip_yz").text('手机号或密码错误');
              /*if (this.islogin > 3) {
                var yanzm = this.yanzm;
                if (yanzm.trim() == '') {
                  $(".denglu").removeClass("vis-hide");
                  $(".tip_yz").text('验证码不能为空');
                } else {
                  $.ajax({
                    url: "/zklccloud/queryYZM?checkMemo=" + yanzm.trim(),
                    type: "post",
                    contentType: 'application/json;charset=UTF-8',
                    async: false,
                    dataType: "json",
                    success: function (m) {
                      var yuz = m.resultCode;
                      if (yuz == -1) {
                        $(".denglu").removeClass("vis-hide");
                        $(".tip_yz").text('验证码错误');
                        temp.istrue = 1;
                        temp.fleshVerify('verifyImg');
                      } else {
                        temp.istrue = 0;
                      }
                    }
                  })
                }
                $(".isyzm").removeClass("vise-hide");
                $(".login_box").css("top", "-13px")
              }*/
            }else if(err.body.errorMsg=='userLockError'){
              $(".tip_yz").text('账户被锁定，请稍后再试');
            }else if(err.body.errorMsg=='checkCodeError'){
              $(".tip_yz").text('验证码错误');
              this.yanzm="";
            }
            return;
          })
        }
      },
      fleshVerify(obj) {
        //重载验证码
        var verify = document.getElementById(obj);
        if(verify){
          verify.setAttribute('src', '/zklccloud/captcha.jpg?' + Math.random());
        }

      },
      inputFocus() {
        var inputF = $(".input_focus");
        for (var i = 0; i < inputF.length; i++) {
          if ($(inputF[i]).val() == '' || $(inputF[i]).val() == null) {
            $(inputF[i]).siblings(".label_focus").removeClass("up");
          } else {
            $(inputF[i]).siblings(".label_focus").addClass("up");
          }
        }
        $(inputF).focus(function () {
          var fn = this;
          if ($(fn).val() == '' || $(fn).val() == null) {
            $(fn).siblings(".label_focus").addClass("up");
          } else {
            return
          }
        })
        $(inputF).blur(function () {
          var fn = this;
          if ($(fn).val() == '' || $(fn).val() == null) {
            $(fn).siblings(".label_focus").removeClass("up")
          } else {
            return
          }
        })
      },
      updatePassword() {
        var temp = this;
        var yanzm = this.user.yzm;
        if (this.user.mobile == '') {
          $(".tip_yz").text('手机号不能为空');
          return;
        } else if (yanzm.trim() == '') {
          $(".tip_yz").text('验证码不能为空');
          return;
        } else {
          $.ajax({
            url: "/zklccloud/queryYZM?checkMemo=" + yanzm.trim(),
            type: "post",
            contentType: 'application/json;charset=UTF-8',
            async: false,
            dataType: "json",
            success: function (m) {
              var yuz = m.resultCode;
              if (yuz == -1) {
                $(".tip_yz").text('验证码错误');
                temp.istrue = 1;
                temp.fleshVerify('verifyImg2');
              } else {
                temp.istrue = 0;
              }
            }
          })
        }
        if (temp.istrue == 0) {
          var formData = JSON.stringify(this.user);
          this.$http.post('/zklccloud/register/checkMob', formData, {emulateJSON: true}).then(function (m) {
            if (m.body.resultCode != 0) {
              var Num = "";
              for (var i = 0; i < 6; i++) {
                Num += Math.floor(Math.random() * 10);
              }
              this.user.memo = Num;
              var formData = JSON.stringify(this.user);
              this.$http.post('/zklccloud/register/zhaohuiMes', formData, {emulateJSON: true}).then(function (m) {
                if (m.body.resultCode == 0) {
                  var mobile = m.body.content.mobile;
                  var yzm = m.body.content.yzm;
                  var memo = m.body.content.memo;
                  this.$router.push({
                    name: 'forget_password',
                    params: {mobile: mobile, memo: memo, yzm: yzm}
                  });
                } else {
                  $(".tip_yz").text('发送验证码失败,请联系管理员!');
                  return;
                }

              })
            } else {
              $(".tip_yz").text('手机号不存在');
              return;
            }
          })
        }
      },
      switchover() { //点击切换效果
        var switchover = $(".switchover");
        $(switchover).click(function () {
          $(".login_box_2,.login_box_3").find(".tip_yz").text('');
          if ($(this).index() == 0) {
            $(switchover[2]).css('height', '310px')
            $(this).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_1")
            $(switchover[1]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_2")
            $(switchover[2]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_3")
          } else if ($(this).index() == 1) {
            $(switchover[2]).css('height', '320px')
            $(this).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_1")
            $(switchover[0]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_2")
            $(switchover[2]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_3")

          } else {
            $(this).css('height', 'auto')
            $(this).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_1")
            $(switchover[0]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_3")
            $(switchover[1]).removeClass("login_box_1 login_box_2 login_box_3").addClass("login_box_2")
          }
        })

      }
    }
  }
</script>

<style>
  .vise-hide {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// login_index.vue?345feece